import { Alert, AlertTitle, Button } from "@mui/material";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { useState } from "react";

/**
 * A persistent banner that displays across the entire app.
 * The banner will remain visible until the feature flag is updated.
 * It can be dismissed by the user if showCloseButton is enabled in the feature flag.
 */
export function OutageBanner() {
  const [isDismissed, setIsDismissed] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const bannerConfig = useCbhFlag(CbhFeatureFlag.DISPLAY_INCIDENT_BANNER, {
    defaultValue: {
      message: "",
      title: "",
      showCloseButton: false,
    },
  });

  if (!bannerConfig.message || isDismissed) {
    return null;
  }

  const isDismissible = bannerConfig.showCloseButton;

  let buttonLabel: string = "";
  let buttonOnClick: undefined | (() => void);
  if (isDismissible) {
    buttonLabel = "Dismiss";
    buttonOnClick = () => setIsDismissed(true);
  } else if (isExpanded) {
    buttonLabel = "Hide";
    buttonOnClick = () => setIsExpanded(false);
  } else {
    buttonLabel = "Show more";
    buttonOnClick = () => setIsExpanded(true);
  }

  return (
    <Alert
      severity="error"
      sx={{
        borderRadius: 0,
        // Enforce line height so that it looks consistent across pages.
        lineHeight: "normal",
        alignItems: "start",
      }}
      variant="filled"
      action={
        <Button
          sx={(theme) => ({ color: theme.palette.error.contrastText, height: "2rem" })}
          size="small"
          onClick={buttonOnClick}
        >
          {buttonLabel}
        </Button>
      }
    >
      <AlertTitle
        sx={(theme) => ({ color: theme.palette.error.contrastText, lineHeight: "1.5rem" })}
      >
        {bannerConfig.title}
      </AlertTitle>
      {isExpanded && <>{bannerConfig.message}</>}
    </Alert>
  );
}
